module.exports = __webpack_public_path__ + "media/src/img/payment/sberbank_logo_mini-fc8b693e02c0aa99772f98cae57373b1.svg";